/**
 * Convert a font size to a dynamic font size.
 * Fonts that participate in Dynamic Type should use
 * dynamic font sizes.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param unit (optional) - The unit to convert to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * Convert a font size to a dynamic font size but impose
 * a maximum font size.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param maxScale - The maximum scale of the font (i.e. 2.5 for a maximum 250% scale).
 * @param unit (optional) - The unit to convert the initial font size to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * Convert a font size to a dynamic font size but impose
 * a minimum font size.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param minScale - The minimum scale of the font (i.e. 0.8 for a minimum 80% scale).
 * @param unit (optional) - The unit to convert the initial font size to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * Convert a font size to a dynamic font size but impose
 * maximum and minimum font sizes.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param minScale - The minimum scale of the font (i.e. 0.8 for a minimum 80% scale).
 * @param maxScale - The maximum scale of the font (i.e. 2.5 for a maximum 250% scale).
 * @param unit (optional) - The unit to convert the initial font size to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * A heuristic that applies CSS to tablet
 * viewports.
 *
 * Usage:
 * @include tablet-viewport() {
 *   :host {
 *     background-color: green;
 *   }
 * }
 */
/**
 * A heuristic that applies CSS to mobile
 * viewports (i.e. phones, not tablets).
 *
 * Usage:
 * @include mobile-viewport() {
 *   :host {
 *     background-color: blue;
 *   }
 * }
 */
:host {
  /**
   * @prop --background: Background of the toolbar
   *
   * @prop --border-color: Color of the toolbar border
   * @prop --border-style: Style of the toolbar border
   * @prop --border-width: Width of the toolbar border
   *
   * @prop --color: Color of the toolbar text
   *
   * @prop --min-height: Minimum height of the toolbar
   *
   * @prop --opacity: Opacity of the toolbar background
   *
   * @prop --padding-top: Top padding of the toolbar
   * @prop --padding-end: Right padding if direction is left-to-right, and left padding if direction is right-to-left of the toolbar
   * @prop --padding-bottom: Bottom padding of the toolbar
   * @prop --padding-start: Left padding if direction is left-to-right, and right padding if direction is right-to-left of the toolbar
   */
  --border-width: 0;
  --border-style: solid;
  --opacity: 1;
  --opacity-scale: 1;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: block;
  position: relative;
  width: 100%;
  padding-right: var(--ion-safe-area-right);
  padding-left: var(--ion-safe-area-left);
  color: var(--color);
  font-family: var(--ion-font-family, inherit);
  contain: content;
  z-index: 10;
  box-sizing: border-box;
}

:host(.ion-color) {
  color: var(--ion-color-contrast);
}

:host(.ion-color) .toolbar-background {
  background: var(--ion-color-base);
}

.toolbar-container {
  -webkit-padding-start: var(--padding-start);
  padding-inline-start: var(--padding-start);
  -webkit-padding-end: var(--padding-end);
  padding-inline-end: var(--padding-end);
  padding-top: var(--padding-top);
  padding-bottom: var(--padding-bottom);
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: var(--min-height);
  contain: content;
  overflow: hidden;
  z-index: 10;
  box-sizing: border-box;
}

.toolbar-background {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: absolute;
  transform: translateZ(0);
  border-width: var(--border-width);
  border-style: var(--border-style);
  border-color: var(--border-color);
  background: var(--background);
  contain: strict;
  opacity: calc(var(--opacity) * var(--opacity-scale));
  z-index: -1;
  pointer-events: none;
}

::slotted(ion-progress-bar) {
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
}

/**
 * Convert a font size to a dynamic font size.
 * Fonts that participate in Dynamic Type should use
 * dynamic font sizes.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param unit (optional) - The unit to convert to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * Convert a font size to a dynamic font size but impose
 * a maximum font size.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param maxScale - The maximum scale of the font (i.e. 2.5 for a maximum 250% scale).
 * @param unit (optional) - The unit to convert the initial font size to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * Convert a font size to a dynamic font size but impose
 * a minimum font size.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param minScale - The minimum scale of the font (i.e. 0.8 for a minimum 80% scale).
 * @param unit (optional) - The unit to convert the initial font size to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * Convert a font size to a dynamic font size but impose
 * maximum and minimum font sizes.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param minScale - The minimum scale of the font (i.e. 0.8 for a minimum 80% scale).
 * @param maxScale - The maximum scale of the font (i.e. 2.5 for a maximum 250% scale).
 * @param unit (optional) - The unit to convert the initial font size to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * A heuristic that applies CSS to tablet
 * viewports.
 *
 * Usage:
 * @include tablet-viewport() {
 *   :host {
 *     background-color: green;
 *   }
 * }
 */
/**
 * A heuristic that applies CSS to mobile
 * viewports (i.e. phones, not tablets).
 *
 * Usage:
 * @include mobile-viewport() {
 *   :host {
 *     background-color: blue;
 *   }
 * }
 */
:host {
  --background: var(--ion-toolbar-background, var(--ion-color-step-50, var(--ion-background-color-step-50, #f7f7f7)));
  --color: var(--ion-toolbar-color, var(--ion-text-color, #000));
  --border-color: var(--ion-toolbar-border-color, var(--ion-border-color, var(--ion-color-step-150, var(--ion-background-color-step-150, rgba(0, 0, 0, 0.2)))));
  --padding-top: 3px;
  --padding-bottom: 3px;
  --padding-start: 4px;
  --padding-end: 4px;
  --min-height: 44px;
}

.toolbar-content {
  flex: 1;
  order: 4;
  min-width: 0;
}

:host(.toolbar-segment) .toolbar-content {
  display: inline-flex;
}

:host(.toolbar-searchbar) .toolbar-container {
  padding-top: 0;
  padding-bottom: 0;
}

:host(.toolbar-searchbar) ::slotted(*) {
  align-self: start;
}

:host(.toolbar-searchbar) ::slotted(ion-chip) {
  margin-top: 3px;
}

::slotted(ion-buttons) {
  min-height: 38px;
}

::slotted([slot=start]) {
  order: 2;
}

::slotted([slot=secondary]) {
  order: 3;
}

::slotted([slot=primary]) {
  order: 5;
  text-align: end;
}

::slotted([slot=end]) {
  order: 6;
  text-align: end;
}

:host(.toolbar-title-large) .toolbar-container {
  flex-wrap: wrap;
  align-items: flex-start;
}

:host(.toolbar-title-large) .toolbar-content ion-title {
  flex: 1;
  order: 8;
  min-width: 100%;
}